import { SectionHeaderBar } from '../../common/components/SectionHeaderBar';

export interface BridgeRepaidProps {}

export const BridgeRepaid = ({}: BridgeRepaidProps) => {
    return (
        <>
            <SectionHeaderBar title={'Repaid'}></SectionHeaderBar>
        </>
    );
};
